// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2T-XR","unreadBadge":"styles_unreadBadge__2sQ4a","modalContent":"styles_modalContent__31XFY","modal":"styles_modal__1b2tB"};